import React, { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import RouteContainer from 'src/components/App/RouteContainer'

const WorkflowDetails = React.lazy(() => loadComponent('traiwiss', 'WorkflowDetails'))

export function WorkflowDetailsRoute() {
    const navigate = useNavigate()
    const params = useParams()

    const gotoTrainingDetails = useCallback(
        (trainingId: string) => {
            navigate(`/trainings/${trainingId}`)
        },
        [navigate],
    )

    return (
        <RouteContainer>
            <WorkflowDetails _id={params._id} gotoTrainingDetails={gotoTrainingDetails} />
        </RouteContainer>
    )
}
